import { useFormikContext } from "formik";
import React, { useEffect } from "react";
export const FormikErrorFocus = () => {
    const { isSubmitting, isValidating, errors } = useFormikContext();
    useEffect(() => {
        const isObject = (value) => {
            return value && typeof value === "object" && value.constructor === Object;
        };
        const getKeysRecursively = (value, depth = 0) => {
            let currentKey;
            let arrayIndex;
            if (Array.isArray(value)) {
                const firstValue = value.find((el, index) => {
                    if (el) {
                        arrayIndex = index;
                        return el;
                    }
                });
                return `[${arrayIndex}]` + getKeysRecursively(firstValue, depth + 1);
            }
            if (!isObject(value))
                return "";
            else
                currentKey = Object.keys(value)[0];
            if (!getKeysRecursively(value[currentKey], depth + 1)) {
                return `${depth > 0 ? `.${currentKey}` : currentKey}`;
            }
            return currentKey + getKeysRecursively(value[currentKey], depth + 1);
        };
        const keys = Object.keys(errors);
        if (keys.length > 0 && isSubmitting && !isValidating) {
            const selectorKey = getKeysRecursively(errors);
            const selector = `[id="${selectorKey}"], [name="${selectorKey}"] `;
            const errorElement = document.querySelector(selector);
            if (errorElement) {
                errorElement === null || errorElement === void 0 ? void 0 : errorElement.focus();
            }
        }
    }, [errors, isSubmitting, isValidating]);
    return React.createElement(React.Fragment, null);
};
//# sourceMappingURL=FormikErrorFocus.js.map